:host {
  display: inline-block;

  /** @prop --foreground-color: Defines the foreground color. */
  --foreground-color: var(--dnn-color-foreground, #000);

  /** @prop --background-color: Defines the background color. */
  --background-color: var(--dnn-color-background, #fff);

  /** @prop --focus-color: Defines the color when the component is focused. */
  --focus-color: var(--dnn-color-primary, #3792ED);

  /** @prop --danger-color: Defines the danger color used for invalid data. */
  --danger-color: var(--dnn-color-danger, #900);

  /** @prop --control-radius: Defines the radius for the control corners. */
  --control-radius: var(--dnn-controls-radius, 3px);
}

dnn-fieldset{
  width: 100%;
}

@keyframes shift {
  0% {
      background-position: 0% 0;
  }
  50% {
      background-position: 100% 0;
  }
  100% {
      background-position: 200% 0;
  }
}

.inner-container{
  display: flex;
  justify-content: space-between;
  position: relative;
  width: 100%;

  input {
    border: none;
    outline: none;
    background-color: transparent;
    color: var(--foreground-color);
    text-align: var(--input-text-align);
    width: 100%;
  }

  svg.chevron-down{
    height: 1rem;
    width: auto;
    transform: scale(1.2);
    fill: var(--foreground-color);
    cursor: pointer;
  }

  ul{
    position: absolute;
    border: 1px solid lightgray;
    margin: 0;
    padding: var(--dnn-controls-radius, 3px) 0;
    overflow-y: auto;
    width: 100%;
    box-shadow: 2px 2px 6px 1px rgb(0 0 0 / 30%);
    background-color: var(--dnn-color-background, white);
    border-radius: var(--dnn-controls-radius, 3px);
    z-index: 2;
    display: none;
    scroll-behavior: smooth;
    &.show{
      display: block;
    }
    li {
      display: block;
      list-style-type: none;
      cursor: pointer;
      padding: 0 0.5rem;
      &.selected {
        background-color: lightgray;
      }
      &:hover {
        background-color: lightgray;
      }
    }
    .loading {
      width: 100%;
      height: 0.5rem;
      border-radius: 0.5rem;
      background: linear-gradient(
        to right,
        var(--background-color) 0%,
        var(--foreground-color) 50%,
        var(--background-color) 100%);
      background-size: 200% 100%;
      animation: shift 2s linear infinite;
      width: 75%;
      margin: 0 auto;
      opacity: 0.5;
    }
  }
}

dnn-fieldset{
  --fieldset-foreground-color: var(--foreground-color);
  --fieldset-background-color: var(--background-color);
  --fieldset-focus-color: var(--focus-color);
  --fieldset-danger-color: var(--danger-color);
  --fieldset-control-radius: var(--control-radius);
}

svg{
  &.error{
    fill: red;
    width: 1em;
    height: 1em;
    transform: scale(1.5);
    margin-right: 0.5em;
  }
}